var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAreaChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17181",
    transform: "translate(534 300)",
    fill: "#3b5175",
    stroke: "#707070",
    d: "M0 0h30v30H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1392",
    transform: "translate(-534 -300)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17184",
    fill: "none",
    d: "M534 300h30v30h-30z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2",
    fill: "#3b5175"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21499",
    d: "M560.188 320.813 556.5 311.5a1.187 1.187 0 0 0-1.687-.687L550 313.375a.563.563 0 0 1-.687-.062l-5.688-6.688a1.25 1.25 0 0 0-2.125.875v15H559a1.313 1.313 0 0 0 1.188-1.687Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21500",
    d: "M560.25 325H539v-21.25a1.25 1.25 0 0 0-2.5 0v23.75h23.75a1.25 1.25 0 0 0 0-2.5Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaChart);
export default __webpack_public_path__ + "static/media/area-chart.8f9d80c01a779d96fcec6b01d25857d1.svg";
export { ForwardRef as ReactComponent };